import React, { useRef } from 'react';
import { RocheButton as RocheButtonType } from '../../types/global';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { NavigationService } from '../../services/navigation';
import { Link } from '../../services/navigation/types';

type RocheButtonProps = BlokToComponentProps<
  RocheButtonType & {
    right_icon?: string;
    left_icon?: string;
    href: Link;
  }
>;

export const RocheButton = ({
  blok: { appearance, href, right_icon: rightIcon, left_icon: leftIcon, target, text },
  slot,
}: RocheButtonProps): JSX.Element => {
  const container = useRef<HTMLButtonElement>(null);

  const buttonHref = NavigationService.getParsedNavigationLink(href);

  return (
    <roche-button
      ref={container}
      appearance={appearance}
      left-icon={leftIcon}
      right-icon={rightIcon}
      target={target}
      href={buttonHref}
      text={text}
      slot={slot}
    >
      {href && <a href={buttonHref}>{text}</a>}
    </roche-button>
  );
};
